import {
  FaBroom,
  FaTools,
  FaHome,
  FaSpa,
  FaTruckMoving,
  FaGraduationCap,
  FaPlane,
  FaFileAlt,
  FaThLarge,
} from "react-icons/fa";

const services = [
  {
    id: 1,
    title: "Cleaning & Pest Control",
    icon: FaBroom,
    link: "/category/cleaning-&-pest-control",
  },
  {
    id: 2,
    title: "Electronics Repair & Services",
    icon: FaTools,
    link: "/category/electronics-repair-&-services",
  },
  {
    id: 3,
    title: "Home Renovation & Repair",
    icon: FaHome,
    link: "/category/home-renovation-&-repair",
  },
  {
    id: 4,
    title: "Health & Beauty",
    icon: FaSpa,
    link: "/category/health-&-beauty",
  },
  {
    id: 5,
    title: "Packers & Movers",
    icon: FaTruckMoving,
    link: "/category/packers-&-movers",
  },
  {
    id: 6,
    title: "Education & Classes",
    icon: FaGraduationCap,
    link: "/category/education-&-classes",
  },
  {
    id: 7,
    title: "Tours & Travel",
    icon: FaPlane,
    link: "/category/tours-&-travel",
  },
  {
    id: 8,
    title: "Legal & Documentation Services",
    icon: FaFileAlt,
    link: "/category/legal-&-documentation-services",
  },
  {
    id: 9,
    title: "Other Services",
    icon: FaThLarge,
    link: "/category/other-services",
  },
];

export default services;